import ReactDOM from 'react-dom/client';
import { RouterProvider } from '@tanstack/react-router';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ApiError } from '@/lib/api';
// import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { createRouter } from './router';

// Create a new QueryClient instance
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: (failureCount, error) => {
        // Do not retry specific client errors (4xx) except 429 Too Many Requests
        if (error instanceof ApiError && error.status && error.status >= 400 && error.status < 500 && error.status !== 429) {
          return false;
        }
        return failureCount < 1;
      },
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: false, // Never automatically retry mutating operations (POST, DELETE, etc.)
    },
  },
});

// Create a new router instance
const router = createRouter();

// Render the app
const rootElement = document.getElementById('root')!;
if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      {/* Disable devtools in mobile prototype as they intercept touches */}
      {/* {import.meta.env.DEV && <ReactQueryDevtools />} */}
    </QueryClientProvider>
  );
}
